import { useCallback, useEffect } from 'react';
import { IUserAccessPermissions } from '../models';
import { UsersApi } from '../../../api/usersApi';

export const useFetchUserAccessPermissions = (
  id: number,
  setInitialState: React.Dispatch<
    React.SetStateAction<IUserAccessPermissions | null>
  >,
  setError: React.Dispatch<React.SetStateAction<string>>
) => {
  const fetchUserAccessPermissions = useCallback(async () => {
    const result = await UsersApi.getUserAccessPermissions(id);
    if (result.data) {
      const data = result.data;
      setInitialState(data);
    }

    if (result.error) {
      const error = result.error.message;
      setError(error);
    }
  }, []);

  useEffect(() => {
    fetchUserAccessPermissions();
  }, []);
};

export default useFetchUserAccessPermissions;
